import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Details, Term, Definition } from '../../common/Details'
import { InfoTooltip } from '../../common/Tooltip'
import { DetailsSection } from '../DetailsSection'
import { IconListGrid, ListItem } from '../../common/IconListGrid'

export const MalwareDetectionNames = ({ malware }) => {
  const [showDetections, setShowDetections] = useState(false)

  const {
    fireeye_detection_names: fireeyeDetectionNames,
  } = malware || {}

  return (
    <DetailsSection title="Detection Names">
      <Details>
        <Term>Detection Names <InfoTooltip tooltip="Security controls detections for this threat." /></Term>
        <Definition>
          <IconListGrid
            list={fireeyeDetectionNames}
            showItems={showDetections}
            setShowItems={setShowDetections}
            type='detections'
            displayLimit={9}
            cellWidths={['100%', '50%', '33.3333%']}
            renderItem={item => {
              return <ListItem>{item}</ListItem>
            }}
          />
        </Definition>
      </Details>
    </DetailsSection>
  )
}

MalwareDetectionNames.propTypes = {
  malware: PropTypes.object
}
